(function () {
  const $ = document.querySelector.bind(document);
  const $$ = document.querySelectorAll.bind(document);
  const $button = $$(".podcast__container-text--audio-play-btn");
  const $secondButton = $(".podcast-player__controls");
  const $durationLineWidth = $(".podcast-player__duration").offsetWidth;
  const $durationLine = $(".podcast-player__duration span:last-child");
  const $fullTimeLine = $(".podcast-player__duration span:first-child");
  const $volume = $(".podcast-player__volume-progress");
  const $volumeWidth = $volume.offsetWidth;
  const $volumeValue = $(".podcast-player__volume span:last-child");
  const $nameField = $(".podcast-player__duration-name");
  const $fullTime = $(".podcast-player__time span:last-child");
  const $currentTime = $(".podcast-player__time span:first-child");
  const $muteBtn = $(".podcast-player__volume-icon");
  const $singleBtn = $$('[data-podcast="single-play"]');
  const loaderSelector = '[data-audio="loader"]';
  const audio = new Audio();
  let volume,
    podcastCurrentTime = 0,
    interval,
    newInterval,
    currentSrc = "";

  audio.volume = 0.5;

  const clearButtons = function () {
    $button.forEach((elem) => {
      elem.classList.remove("playing", "paused");
    });
  };

  const convertHMS = function (value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;
    if (seconds < 10) seconds = "0" + seconds;
    return minutes + ":" + seconds;
  };

  const showPlayer = function (status) {
    const $player = $(".podcast-player");
    if (status) {
      $player.classList.add("podcast-player__show");
      document.body.classList.add("podcast_play");
    } else {
      $player.classList.remove("podcast-player__show");
      document.body.classList.remove("podcast_play");
      if ($singleBtn.length !== 0) {
        $singleBtn.forEach((btn) => btn.classList.remove("playing", "paused"));
      }
      if ($button.length !== 0) {
        clearButtons();
      }
    }
  };

  if (window.innerWidth < 780) {
    $secondButton.addEventListener("mouseenter", function () {
      this.querySelector("svg path").style.fill = "hsla(0,0%,100%,.8)";
    });
    $secondButton.addEventListener("mouseleave", function () {
      this.querySelector("svg path").style.fill = "#fff";
    });
  }

  const changeVolumeValue = function (e, element) {
    const elementOffset = element.getBoundingClientRect();
    const pos = e.pageX - elementOffset.left;
    const value = pos / $volumeWidth;
    audio.volume = value;
    audio.muted = value < 0.075;

    if (value < 0.075) {
      $muteBtn.classList.add("muted");
      $volumeValue.style.left = `-${$volumeWidth}px`;
    } else {
      $muteBtn.classList.remove("muted");
      $volumeValue.style.left = `-${$volumeWidth - pos}px`;
    }
  };

  const countTime = function (e, element) {
    const elementOffset = element.parentElement.getBoundingClientRect();
    const pos = e.pageX - elementOffset.left;

    if (!$durationLineWidth || $durationLineWidth <= 0) {
      console.error("Invalid $durationLineWidth:", $durationLineWidth);
      return;
    }

    if (isNaN(audio.duration) || !isFinite(audio.duration)) {
      console.error("Audio duration is not ready yet.");
      return;
    }

    const currentTime = (pos * audio.duration) / $durationLineWidth;

    if (!isFinite(currentTime) || isNaN(currentTime)) {
      console.error("Invalid currentTime calculated:", currentTime);
      return;
    }

    audio.currentTime = currentTime;
    podcastCurrentTime = audio.currentTime;
    $durationLine.style.width = `${pos}px`;
  };

  // Ensure duration is available before user interacts
  audio.addEventListener("loadedmetadata", () => {
    console.log("Audio duration available:", audio.duration);
  });

  const playPodcast = function (element) {
    $nameField.textContent = element.dataset.audioName;
    const fileSrc = element.dataset.audio;
    if (!element.classList.contains("playing")) {
      if (currentSrc === "") {
        audio.src = fileSrc;
        currentSrc = audio.src;
      } else if (!element.classList.contains("pause")) {
        audio.src = fileSrc;
        clearButtons();
        audio.currentTime = podcastCurrentTime = 0;
      }
      audio.play();
      audio.currentTime = podcastCurrentTime;
      interval = setInterval(function () {
        const duration = audio.duration;
        podcastCurrentTime = audio.currentTime;
        if (!isNaN(duration)) {
          $fullTime.textContent = convertHMS(duration);
          $currentTime.textContent = convertHMS(podcastCurrentTime);
        }
        if (duration !== podcastCurrentTime) {
          $durationLine.style.width = `${
            ($durationLineWidth * podcastCurrentTime) / duration
          }px`;
        }
      }, 1000);
    } else {
      clearInterval(interval);
      audio.pause();
    }
  };

  if ($singleBtn.length !== 0) {
    $singleBtn.forEach((btn) => {
      btn.addEventListener("click", function () {
        playPodcast(this);
        if (!this.classList.contains("playing")) {
          $secondButton?.classList.add("loading");
          this.classList.add("loading");
          const $loader = this.querySelector(loaderSelector);
          const self = this;
          newInterval = setInterval(function () {
            if (audio.currentTime === 0) {
              $loader.classList.add("visible");
              $secondButton
                ?.querySelector(loaderSelector)
                .classList.add("visible");
            } else {
              clearButtons();
              showPlayer(true);
              $secondButton?.classList.add("playing");
              $secondButton?.classList.remove("loading");
              $secondButton
                ?.querySelector(loaderSelector)
                .classList.remove("visible");
              self.classList.add("playing", "paused");
              self.classList.remove("pause", "loading");
              $loader.classList.remove("visible");
              clearInterval(newInterval);
            }
          });
        } else {
          clearInterval(newInterval);
          $secondButton?.classList.remove("playing");
          this.classList.remove("playing", "paused");
          this.classList.add("pause");
        }
      });
    });

    $secondButton?.addEventListener("click", function () {
      let playingButtonClass =
        $(".podcast__single-sidebar--play.playing") ||
        $(".podcast__single-sidebar--play.pause");
      playPodcast(playingButtonClass);
      if (!playingButtonClass.classList.contains("playing")) {
        playingButtonClass.classList.add("playing", "paused");
        playingButtonClass.classList.remove("pause");
        this.classList.add("playing");
      } else {
        playingButtonClass.classList.remove("playing", "paused");
        playingButtonClass.classList.add("pause");
        this.classList.remove("playing");
      }
      if (window.innerWidth < 780) {
        this.querySelector("svg path").style.fill = "#fff";
      }
    });
  }

  if ($button.length !== 0) {
    $button.forEach((btn) => {
      btn.addEventListener("click", function () {
        playPodcast(this);
        if (!this.classList.contains("playing")) {
          $secondButton.classList.add("loading");
          this.classList.add("loading");
          const $loader = this.querySelector(loaderSelector);
          const self = this;
          newInterval = setInterval(function () {
            if (audio.currentTime === 0) {
              $loader.classList.add("visible");
              $secondButton
                .querySelector(loaderSelector)
                .classList.add("visible");
            } else {
              clearButtons();
              showPlayer(true);
              $secondButton.classList.add("playing");
              $secondButton.classList.remove("loading");
              $secondButton
                .querySelector(loaderSelector)
                .classList.remove("visible");
              self.classList.add("playing", "paused");
              self.classList.remove("pause", "loading");
              $loader.classList.remove("visible");
              clearInterval(newInterval);
            }
          });
        } else {
          clearInterval(newInterval);
          $secondButton.classList.remove("playing");
          this.classList.remove("playing", "paused");
          this.classList.add("pause");
        }
      });
    });

    $secondButton?.addEventListener("click", function () {
      let playingButtonClass =
        $(".podcast__container-text--audio-play-btn.playing") ||
        $(".podcast__container-text--audio-play-btn.pause");
      playPodcast(playingButtonClass);
      if (!playingButtonClass.classList.contains("playing")) {
        playingButtonClass.classList.add("playing", "paused");
        playingButtonClass.classList.remove("pause");
        this.classList.add("playing");
      } else {
        playingButtonClass.classList.remove("playing", "paused");
        playingButtonClass.classList.add("pause");
        this.classList.remove("playing");
      }

      if (window.innerWidth < 780) {
        this.querySelector("svg path").style.fill = "#fff";
      }
    });
  }

  $fullTimeLine.addEventListener("click", function (e) {
    countTime(e, this);
  });

  $volume.addEventListener("click", function (e) {
    changeVolumeValue(e, this);
  });

  $durationLine.addEventListener("click", function (e) {
    countTime(e, this);
  });

  $muteBtn.addEventListener("click", function () {
    if (!this.classList.contains("muted")) {
      this.classList.add("muted");
      audio.muted = true;
      volume = audio.volume;
      $volumeValue.style.left = `-${$volumeWidth}px`;
    } else {
      this.classList.remove("muted");
      audio.muted = false;
      audio.volume = volume;
      $volumeValue.style.left = `-${$volumeWidth - volume * $volumeWidth}px`;
    }
  });
})();
